import localVideo from "../../../../src/pages/components/Video/local-video.mp4";
import localPoster from "../../../../src/pages/components/Video/local-poster.jpg";
import * as React from 'react';
export default {
  localVideo,
  localPoster,
  React
};